var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center " },
    [
      _c(
        "v-dialog",
        {
          attrs: { width: "1000", relative: "", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "d-none",
              staticStyle: {
                position: "fixed",
                "z-index": "999",
                width: "200px",
              },
            },
            [
              _c("div", {
                staticClass: "cityDefinition",
                staticStyle: { width: "600px", height: "400px" },
                attrs: { id: "map" },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cityDefinition,
                    expression: "cityDefinition",
                  },
                ],
                attrs: { type: "text", id: "cityDefinition" },
                domProps: { value: _vm.cityDefinition },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cityDefinition = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("button", { on: { click: _vm.find__button } }, [
                _vm._v("cityDefinitionF"),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.terms_of_use == false
            ? _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-auto dialog__close ",
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline" },
                [
                  _vm.terms_of_use == false
                    ? _vm._t("title", function () {
                        return [
                          _c("div", { staticClass: "h2_title" }, [
                            _vm._v("Мы Вам перезвоним"),
                          ]),
                        ]
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.terms_of_use
                    ? _c("div", { staticClass: "terms_of_use__title " }, [
                        _c("div", { staticClass: "h2_title" }, [
                          _vm._v("Условия использования персональных данных"),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _vm.terms_of_use
                    ? _c(
                        "div",
                        { staticClass: "terms_of_use terms_of_use_custom" },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(_vm.terms) },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-30" }, [
                            _c(
                              "button",
                              {
                                staticClass: "px-30 btn_bordered ",
                                on: {
                                  click: function ($event) {
                                    _vm.terms_of_use = false
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            Прочитал\n                        "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("content", function () {
                    return [
                      _vm.terms_of_use == false
                        ? _c(
                            "v-form",
                            {
                              ref: "form",
                              staticClass: "form_upload mainForm",
                              attrs: {
                                name: "landingForm",
                                "lazy-validation": "",
                              },
                              on: {
                                submit: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                              model: {
                                value: _vm.valid,
                                callback: function ($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid",
                              },
                            },
                            [
                              _c("div", { staticClass: "row mx-0 my-0 " }, [
                                _c("div", { staticClass: "col-12 py-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form_upload__item" },
                                    [
                                      _vm.language == "ru"
                                        ? _c(
                                            "label",
                                            { attrs: { for: "name" } },
                                            [
                                              _vm._v("ФИО "),
                                              _c(
                                                "span",
                                                { staticClass: "red" },
                                                [_vm._v(" *")]
                                              ),
                                            ]
                                          )
                                        : _vm.language == "en"
                                        ? _c(
                                            "label",
                                            { attrs: { for: "name" } },
                                            [
                                              _vm._v("Full name "),
                                              _c(
                                                "span",
                                                { staticClass: "red" },
                                                [_vm._v(" *")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.language == "ru"
                                        ? _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.nameRulesRu,
                                              required: "",
                                              solo: "",
                                              id: "name",
                                            },
                                            model: {
                                              value: _vm.name,
                                              callback: function ($$v) {
                                                _vm.name = $$v
                                              },
                                              expression: "name",
                                            },
                                          })
                                        : _vm.language == "en"
                                        ? _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.nameRules,
                                              required: "",
                                              solo: "",
                                              id: "name",
                                            },
                                            model: {
                                              value: _vm.name,
                                              callback: function ($$v) {
                                                _vm.name = $$v
                                              },
                                              expression: "name",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 py-0" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form_upload__item item_tel position-relative",
                                    },
                                    [
                                      _c("label", { attrs: { for: "tel" } }, [
                                        _vm._v("Телефон "),
                                        _c("span", { staticClass: "red" }, [
                                          _vm._v(" *"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: "# ### ###-##-##",
                                            expression: "'# ### ###-##-##'",
                                          },
                                        ],
                                        staticClass: " pl-0",
                                        attrs: {
                                          rules: _vm.tel_inputRulesRu,
                                          required: "",
                                          solo: "",
                                          id: "tel",
                                          oninput:
                                            "this.value = this.value.replace(/[^\\d]/g,'');",
                                        },
                                        model: {
                                          value: _vm.tel_input,
                                          callback: function ($$v) {
                                            _vm.tel_input = $$v
                                          },
                                          expression: "tel_input",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 py-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form_upload__item" },
                                    [
                                      _c("label", { attrs: { for: "city" } }, [
                                        _vm._v("Город "),
                                        _c("span", { staticClass: "red" }, [
                                          _vm._v(" *"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          rules: _vm.cityRulesRu,
                                          required: "",
                                          solo: "",
                                          id: "city",
                                        },
                                        model: {
                                          value: _vm.city,
                                          callback: function ($$v) {
                                            _vm.city = $$v
                                          },
                                          expression: "city",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 py-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form_upload__item" },
                                    [
                                      _c("label", { attrs: { for: "email" } }, [
                                        _vm._v("E-mail "),
                                        _c("span", { staticClass: "red" }, [
                                          _vm._v(" *"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _vm.language == "ru"
                                        ? _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.emailRulesRu,
                                              required: "",
                                              solo: "",
                                              id: "email",
                                            },
                                            model: {
                                              value: _vm.email,
                                              callback: function ($$v) {
                                                _vm.email = $$v
                                              },
                                              expression: "email",
                                            },
                                          })
                                        : _vm.language == "en"
                                        ? _c("v-text-field", {
                                            attrs: {
                                              rules: _vm.emailRules,
                                              required: "",
                                              solo: "",
                                              id: "email",
                                            },
                                            model: {
                                              value: _vm.email,
                                              callback: function ($$v) {
                                                _vm.email = $$v
                                              },
                                              expression: "email",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 py-0" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form_upload__item item_tel position-relative",
                                    },
                                    [
                                      _vm.language == "ru"
                                        ? _c("label", [
                                            _vm._v(
                                              "Выберите удобный вид связи"
                                            ),
                                          ])
                                        : _vm.language == "en"
                                        ? _c("label", [
                                            _vm._v(
                                              "Choose a convenient way of\n                                        communication"
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.language == "ru"
                                        ? _c("v-select", {
                                            staticClass:
                                              " d-flex align-items-center",
                                            attrs: {
                                              items: _vm.type_appealRu,
                                              "menu-props": {
                                                contentClass: "wrap_selfilter",
                                              },
                                              "item-value": "sel_id",
                                              solo: "",
                                              "append-icon":
                                                "mdi mdi-chevron-down",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          src: data.item.icon,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              data.item.name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        staticClass: "d-none",
                                                        attrs: {
                                                          type: "text",
                                                          id: "TypeOfCommunication",
                                                        },
                                                        domProps: {
                                                          value: data.item.name,
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          src: data.item.icon,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              data.item.name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1405930260
                                            ),
                                            model: {
                                              value: _vm.type_appeal_sel.sel_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.type_appeal_sel,
                                                  "sel_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "type_appeal_sel.sel_id",
                                            },
                                          })
                                        : _vm.language == "en"
                                        ? _c("v-select", {
                                            staticClass:
                                              " d-flex align-items-center",
                                            attrs: {
                                              items: _vm.type_appeal,
                                              "menu-props": {
                                                contentClass: "wrap_selfilter",
                                              },
                                              "item-value": "sel_id",
                                              solo: "",
                                              "append-icon":
                                                "mdi mdi-chevron-down",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function (data) {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          src: data.item.icon,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              data.item.name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "item",
                                                  fn: function (data) {
                                                    return [
                                                      _c("img", {
                                                        attrs: {
                                                          src: data.item.icon,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "pl-2" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              data.item.name
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2567047484
                                            ),
                                            model: {
                                              value: _vm.type_appeal_sel.sel_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.type_appeal_sel,
                                                  "sel_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "type_appeal_sel.sel_id",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-12 py-0" },
                                  [
                                    _c("div", {
                                      staticClass: "w-100 mb-2",
                                      class: _vm.captchaPassed
                                        ? ""
                                        : "error-captcha",
                                      attrs: { id: "captcha-container-footer" },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form_upload__item  mt-30",
                                      },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            rules: [
                                              function (v) {
                                                return (
                                                  !!v ||
                                                  "Это обязательный пункт"
                                                )
                                              },
                                            ],
                                            required: "",
                                            color: "red",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "customLabelForm",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Я выражаю согласие с "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "javascript:void(0);",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.terms_of_use = true
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "условиями\n                                                использования"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " моих персональных данных для обработки данного\n                                                обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,\n                                                Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,\n                                                этаж 2), я ознакомлен и выражаю согласие с\n                                                "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.policy,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.linkOpen(
                                                                  _vm.policy
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Политикой\n                                                    конфиденциальности"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" и "),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: _vm.agreement,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.linkOpen(
                                                                  _vm.agreement
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Пользовательским\n                                                соглашением."
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1501761241
                                          ),
                                          model: {
                                            value: _vm.checkbox,
                                            callback: function ($$v) {
                                              _vm.checkbox = $$v
                                            },
                                            expression: "checkbox",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("v-checkbox", {
                                          staticClass: "mt-0",
                                          attrs: { color: "red" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "customLabelForm",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Я выражаю согласие на информирование меня о продуктах, акциях,\n                                                выгодных предложениях, новостях\n                                                ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская\n                                                область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и\n                                                партнеров.\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2144415256
                                          ),
                                          model: {
                                            value: _vm.consentToInform,
                                            callback: function ($$v) {
                                              _vm.consentToInform = $$v
                                            },
                                            expression: "consentToInform",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn_form d-flex align-items-center justify-content-end mb-35",
                                          },
                                          [
                                            _vm.language == "ru"
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticClass:
                                                      "px-30 btn_red w-mc",
                                                    attrs: {
                                                      disabled: !_vm.valid,
                                                    },
                                                    on: { click: _vm.validate },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            Отправить\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }